import React, { useEffect, useState } from 'react'
import { T } from '../../traks'
import { APIGet, APIPost } from '../../API'
import { RenderIf } from '../../helpers/RenderIf'
import { TextArea } from '../Input'
import { Loading } from '../Loading'
import { AlertModal } from '../Modals'
import { ConfirmContent } from '../Modals/ConfirmModal'
import Dropdown from '../DropDown'

const SetRecipient = ({ shareSettings, setShareSettings, recipients }) => (
	<Dropdown toggleText={shareSettings.screen_name || <T>Choose recipient</T>}>
		{recipients.map((recipient, index) => (
			<button
				onClick={() => setShareSettings({ ...shareSettings, ...recipient })}
				key={'d' + index}
			>
				{recipient.screen_name}
			</button>
		))}
	</Dropdown>
)

const AssignWhistle = ({ whistle, ...props }) => {
	const [showAlert, setShowAlert] = useState(false)
	const [showConfirm, setShowConfirm] = useState(false)
	const assignedUser = whistle.access[0]
	const whistle_access_id = whistle.whistle_access_id || null
	const whistle_id = whistle.id
	const [showLoading, setShowLoading] = useState(false)
	const [companySettings, setCompanySettings] = useState(undefined);
	const [alertType, setAlertType] = useState({ type: "", text: "" })
	const [shareSettings, setShareSettings] = useState({
		action: "assign_whistle",
		recipient_id: null,
		screen_name: null,
		company_id: whistle.company_id,
		access_id: whistle_access_id
	})
	const confirmText = {
		header: props.render_static(<T>Share Entry</T>),
		body: props.render_static(<T>Are you sure you want to give access to the entry?</T>)
	}
	const isSubmitButtonDisabled = () => {
		if (!shareSettings.screen_name)
			return true
		return false
	}

	const getRecipients = (companySettings, assignedUser) => {
		const { screen_name } = assignedUser
		return companySettings.assignee_recipients.filter(rec => rec.screen_name !== screen_name)
	}

	const getCompanySettings = () => {
		setShowLoading(true)
		const resource = `companies/${whistle.company_id}`
		APIGet(resource).then(res => {
			setShowLoading(false)
			setCompanySettings(res.data)
		}).catch(err => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
		})
	}

	const AssignWhistle = () => {
		if (!showConfirm) {
			setShowConfirm(true)
			return
		}

		setShowConfirm(false)
		setShowLoading(true)
		const resource = "whistles/" + whistle_id
		APIPost(resource, shareSettings).then(res => {
			setShowLoading(false)
			setAlertType({ type: "success", text: "Entry successfully re-assigned" })
			setShowAlert(true)
			setTimeout(() => {
				window.location.reload();
			}, 1000)
		}).catch(err => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
		})
	}

	useEffect(() => {
		getCompanySettings()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	if (companySettings === undefined)
		return (
			<>
				<Loading
					showLoading={true}
					inFront
				/>
				<AlertModal
					isShowing={showAlert}
					setIsShowing={setShowAlert}
					type={alertType.type}
					text={alertType.text}
				/>
			</>
		)

	const recipients = getRecipients(companySettings, assignedUser)
	return (
		<RenderIf condition={companySettings !== undefined}>
			<RenderIf condition={!showConfirm} >
				<SetRecipient
					shareSettings={shareSettings}
					setShareSettings={setShareSettings}
					recipients={recipients}
				/>

				<div className="mt-5">
					<TextArea
						placeholder=<T>comment</T>
						onChange={(e) => { setShareSettings({ ...shareSettings, comment: e }) }}
					/>
				</div>
				<button
					className="btn btn_green mt-5 mb-3"
					disabled={isSubmitButtonDisabled()}
					onClick={AssignWhistle}
				>
					<T>RE-ASSIGN</T>
				</button>
			</RenderIf>
			<RenderIf condition={showConfirm}>
				<ConfirmContent
					header={confirmText.header}
					body={confirmText.body}
					hide={() => setShowConfirm(false)}
					onConfirm={AssignWhistle}
				/>
			</RenderIf>
			<Loading
				showLoading={showLoading}
				inFront
			/>
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={alertType.type}
				text={alertType.text}
			/>
		</RenderIf>
	)
}

export default AssignWhistle
